module.exports = __webpack_public_path__ + "fonts/gothica1-extrabold-webfont.4db91d5.woff2";